import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";
import { FORMS_ROUTE, SUBMITTED_FORMS_ROUTE } from "../../dashboard-routes";
import { formInfo } from "../forms/form-info";

const DashboardSubmittedFormsTable = () => {
    const tableHeader = [
        { name: "Form Id", key: "formId" },
        { name: "Form Title", key: "formTitle" },
        { name: "Submitted By", key: "submittedBy" },
        { name: "Date", key: "submittedAt" },
    ];

    const [displayData, setDisplayData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        var config = {
            method: "get",
            url: dataProvider.baseUrl + "forms-getFormsByOrgId",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
        };

        axios(config)
            .then(function (response) {
                //console.log("Forms", response.data);
                setIsLoading(false);
                let data = parseData(response.data);
                setDisplayData(data);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
            });
    }, []);

    function parseData(data) {
        let allFormData = [];

        data.forEach((formState) => {
            let formInfoTemp = formInfo.find((f) => f.formType === formState.formType);

            if (formInfoTemp)
                allFormData.push({
                    formId: (
                        <Link
                            to={{
                                pathname: DASHBOARD_ROUTE + FORMS_ROUTE + formInfoTemp.path,
                                state: {
                                    editForm: true,
                                    formState,
                                },
                            }}
                        >
                            {formState.formId}
                        </Link>
                    ),
                    formTitle: formState.formTitle,
                    submittedBy: formState?.lastEditedByUserDetails?.fullName,
                    submittedAt: new Date(formState.lastEditedTimeStamp).toDateString(),
                    lastEditedTimeStamp: formState.lastEditedTimeStamp,
                });
        });

        allFormData = allFormData.sort((a, b) => {
            if (a.lastEditedTimeStamp > b.lastEditedTimeStamp) return -1;
            else if (a.lastEditedTimeStamp < b.lastEditedTimeStamp) return 1;
            else return 0;
        });

        allFormData = allFormData.slice(0, 10);

        return allFormData;
    }

    return (
        <div className="container-fluid p-3">
            <div className="card border-0">
                <div className="card-header py-3 d-flex bg-white align-items-center justify-content-between">
                    <b>Submitted Forms</b>
                    <Link className="btn btn-primary text-light" to={DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE}>
                        View All Submitted Forms
                    </Link>
                </div>
                <div className="card-body p-3">
                    {isLoading ? (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Submitted Forms</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div style={{ overflow: "auto" }}>
                            <DataTable 
                                header={tableHeader}
                                rawData={displayData} 
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DashboardSubmittedFormsTable;
